var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _g, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEgipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 193,
    viewBox: "0 0 304 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.7406 117.674H50.6853V143.148H85.7406V117.674Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3849 128.119H60.0405V143.148H76.3849V128.119Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0191 125.038H58.4062V128.119H78.0191V125.038Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3849 117.674H60.0405V125.038H76.3849V117.674Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6472 117.674H60.0405V125.038H63.6472V117.674Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6472 128.119H60.0405V143.148H63.6472V128.119Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0159 128.119H66.4092V143.148H70.0159V128.119Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3848 117.674H72.7781V125.038H76.3848V117.674Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3848 128.119H72.7781V143.148H76.3848V128.119Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4092 128.119H63.6477V143.148H66.4092V128.119Z",
    fill: "#37474F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7774 128.119H70.0159V143.148H72.7774V128.119Z",
    fill: "#37474F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.844 131.002V138.987",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2129 131.002V138.987",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5811 131.002V138.987",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4092 117.674H63.6477V125.038H66.4092V117.674Z",
    fill: "#37474F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7774 117.674H70.0159V125.038H72.7774V117.674Z",
    fill: "#37474F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.844 119.552V123.009",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2129 119.552V123.009",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5811 119.552V123.009",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8242 139.842H53.2214V132.449C53.2214 131.178 54.252 130.147 55.5228 130.147C56.7942 130.147 57.8242 131.178 57.8242 132.449V139.842Z",
    fill: "#37474F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2046 139.842H78.6018V132.449C78.6018 131.178 79.6324 130.147 80.9032 130.147C82.1746 130.147 83.2046 131.178 83.2046 132.449V139.842Z",
    fill: "#37474F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7406 114.593H50.6853V117.674H85.7406V114.593Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7406 106.176H50.6853V114.593H85.7406V106.176Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1528 110.22C70.1528 111.292 69.2842 112.16 68.213 112.16C67.1417 112.16 66.2732 111.292 66.2732 110.22C66.2732 109.149 67.1417 108.281 68.213 108.281C69.2842 108.281 70.1528 109.149 70.1528 110.22Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7406 95.3557H50.6853V106.176H85.7406V95.3557Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2337 95.3557H50.6853V106.176H53.2337V95.3557Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3599 95.3557H58.8115V106.176H61.3599V95.3557Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4869 95.3557H66.9385V106.176H69.4869V95.3557Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6136 95.3557H75.0652V106.176H77.6136V95.3557Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7405 95.3557H83.1921V106.176H85.7405V95.3557Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6853 98.6241H85.7406",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8121 100.907H55.2339V103.894H56.8121V100.907Z",
    fill: "#37474F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9383 100.907H63.3601V103.894H64.9383V100.907Z",
    fill: "#37474F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0653 100.907H71.4871V103.894H73.0653V100.907Z",
    fill: "#37474F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M81.192 100.907H79.6138V103.894H81.192V100.907Z",
    fill: "#37474F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6853 95.3556C50.6853 85.7066 58.5073 77.884 68.1569 77.884H68.2696C77.9187 77.884 85.7412 85.706 85.7412 95.3556H50.6853Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4775 95.3556C59.4775 85.7066 63.3762 77.884 68.1853 77.884H68.2414C73.0505 77.884 76.9491 85.706 76.9491 95.3556H59.4775Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3601 78.5512V75.855H73.0652V78.5512",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4869 71.9476H64.9382V75.8555H71.4869V71.9476Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2129 67.5143C66.4043 67.5143 64.9382 68.9804 64.9382 70.7889V71.9482H71.4869V70.7889C71.4869 68.9797 70.0208 67.5143 68.2129 67.5143Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0896 73.0559V74.7468",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2129 73.0559V74.7468",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3357 73.0559V74.7468",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2129 67.5143V64.5834",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6852 117.674H43.1331V143.148H50.6852V117.674Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1331 114.593H27.5779V143.148H43.1331V114.593Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6852 114.593H43.1331V117.674H50.6852V114.593Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6853 130.148H27.5779",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9377 143.148H44.8801V137.023C44.8801 135.903 45.7887 134.994 46.9092 134.994C48.0297 134.994 48.9383 135.903 48.9383 137.023L48.9377 143.148Z",
    fill: "#37474F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3846 139.842H33.3264V135.239C33.3264 134.119 34.235 133.21 35.3555 133.21C36.476 133.21 37.3846 134.119 37.3846 135.239V139.842Z",
    fill: "#37474F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3846 125.639H33.3264V121.037C33.3264 119.916 34.235 119.008 35.3555 119.008C36.476 119.008 37.3846 119.916 37.3846 121.037V125.639Z",
    fill: "#37474F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9377 130.148H44.8801V124.023C44.8801 122.903 45.7887 121.994 46.9092 121.994C48.0297 121.994 48.9383 122.903 48.9383 124.023L48.9377 130.148Z",
    fill: "#37474F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5779 114.593H9.76807V143.148H27.5779V114.593Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5779 114.593H9.76807V117.674H27.5779V114.593Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8407 120.604H12.1353V127.48H14.8407V120.604Z",
    fill: "#37474F"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0258 120.604H17.3203V127.48H20.0258V120.604Z",
    fill: "#37474F"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2111 120.604H22.5056V127.48H25.2111V120.604Z",
    fill: "#37474F"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8407 132.196H12.1353V139.071H14.8407V132.196Z",
    fill: "#37474F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0258 132.196H17.3203V139.071H20.0258V132.196Z",
    fill: "#37474F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2111 132.196H22.5056V139.071H25.2111V132.196Z",
    fill: "#37474F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9092 110.385H35.3555V114.593H46.9092V110.385Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0918 107.078H36.1724V110.384H46.0918V107.078Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1323 103.321L37.3845 107.078H41.1323H44.88L41.1323 103.321Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7598 110.385V108.281",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1323 110.385V108.281",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5044 110.385V108.281",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7403 143.148H93.2925V117.674H85.7403V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2924 143.148H108.848V114.593H93.2924V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7403 117.674H93.2925V114.592H85.7403V117.674Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7405 130.148H108.848",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4874 143.148H91.545V137.023C91.545 135.903 90.637 134.994 89.5159 134.994C88.3954 134.994 87.4868 135.903 87.4868 137.023L87.4874 143.148Z",
    fill: "#37474F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0411 139.842H103.099V135.239C103.099 134.119 102.19 133.21 101.07 133.21C99.9491 133.21 99.0405 134.119 99.0405 135.239L99.0411 139.842Z",
    fill: "#37474F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0411 125.639H103.099V121.037C103.099 119.916 102.19 119.008 101.07 119.008C99.9491 119.008 99.0405 119.916 99.0405 121.037L99.0411 125.639Z",
    fill: "#37474F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4874 130.148H91.545V124.023C91.545 122.903 90.637 121.994 89.5159 121.994C88.3954 121.994 87.4868 122.903 87.4868 124.023L87.4874 130.148Z",
    fill: "#37474F"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M108.848 143.148H126.657V114.593H108.848V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M108.848 117.674H126.657V114.592H108.848V117.674Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M121.585 127.48H124.29V120.605H121.585V127.48Z",
    fill: "#37474F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M116.399 127.48H119.105V120.605H116.399V127.48Z",
    fill: "#37474F"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M111.215 127.48H113.92V120.605H111.215V127.48Z",
    fill: "#37474F"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M121.585 139.072H124.29V132.196H121.585V139.072Z",
    fill: "#37474F"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M116.399 139.072H119.105V132.196H116.399V139.072Z",
    fill: "#37474F"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M111.215 139.072H113.92V132.196H111.215V139.072Z",
    fill: "#37474F"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5164 114.593H101.07V110.385H89.5164V114.593Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3337 110.385H100.253V107.079H90.3337V110.385Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2935 103.321L99.0413 107.078H95.2935H91.5452L95.2935 103.321Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6653 110.385V108.281",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2935 110.385V108.281",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9209 110.385V108.281",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M185.482 103.321H152.127V143.149H185.482V103.321Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M152.127 103.321H138.482V143.149H152.127V103.321Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M199.127 103.321H185.482V143.149H199.127V103.321Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M199.128 103.321H138.482V107.079H199.128V103.321Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M199.128 107.078H138.482V110.836H199.128V107.078Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M164.172 143.148H154.907V121.995L159.54 118.49L164.172 121.995V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M162.993 143.148H156.086V129.148L159.54 126.829L162.993 129.148V143.148Z",
    fill: "#37474F"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M172.258 143.148H165.352V129.148L168.805 126.829L172.258 129.148V143.148Z",
    fill: "#37474F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M181.524 143.148H174.617V129.148L178.07 126.829L181.524 129.148V143.148Z",
    fill: "#37474F"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M173.437 143.148H164.172V121.995L168.805 118.49L173.437 121.995V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M182.703 143.148H173.437V121.995L178.07 118.49L182.703 121.995V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M181.881 116.133H155.729V118.49H181.881V116.133Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M141.309 99.6227H138.482V103.321H141.309V99.6227Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M147.733 99.6227H144.906V103.321H147.733V99.6227Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M154.158 99.6227H151.331V103.321H154.158V99.6227Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M160.582 99.6227H157.755V103.321H160.582V99.6227Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M167.006 99.6227H164.179V103.321H167.006V99.6227Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M173.431 99.6227H170.604V103.321H173.431V99.6227Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M179.855 99.6227H177.028V103.321H179.855V99.6227Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M186.279 99.6227H183.452V103.321H186.279V99.6227Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M192.703 99.6227H189.876V103.321H192.703V99.6227Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M199.128 99.6227H196.301V103.321H199.128V99.6227Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M177.028 92.7999H160.582V103.321H177.028V92.7999Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M158.529 92.7999H179.081",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M160.582 92.7998V91.4631C160.582 86.9219 164.264 83.2401 168.805 83.2401C173.347 83.2401 177.028 86.9219 177.028 91.4631V92.7998H160.582Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M162.763 94.4003V97.601",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M165.784 94.4003V97.601",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M168.805 94.4003V97.601",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M171.826 94.4003V97.601",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M174.847 94.4003V97.601",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M168.805 83.2402V77.2034",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M154.253 95.0287H141.29V103.321H154.253V95.0287Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M139.672 95.0287H155.871",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M141.29 95.0286V93.9746C141.29 90.395 144.192 87.493 147.772 87.493C151.351 87.493 154.253 90.395 154.253 93.9746V95.0286H141.29Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M143.009 96.2896V98.8127",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M145.391 96.2896V98.8127",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M147.772 96.2896V98.8127",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M150.153 96.2896V98.8127",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M152.534 96.2896V98.8127",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M147.772 87.4931V82.7345",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M196.358 95.0287H183.395V103.321H196.358V95.0287Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M181.777 95.0287H197.976",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M183.395 95.0286V93.9746C183.395 90.395 186.297 87.493 189.876 87.493C193.456 87.493 196.358 90.395 196.358 93.9746V95.0286H183.395Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M185.114 96.2896V98.8127",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M187.496 96.2896V98.8127",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M189.876 96.2896V98.8127",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M192.257 96.2896V98.8127",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M194.639 96.2896V98.8127",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M189.876 87.4931V82.7345",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M138.482 91.2605H131.154V143.148H138.482V91.2605Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M134.818 88.0204H128.347L131.154 91.2605H134.818H138.482L141.29 88.0204H134.818Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M141.29 85.3882H128.347V88.0204H141.29V85.3882Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M134.914 77.5989H128.442L131.25 80.8397H134.914H138.578L141.386 77.5989H134.914Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M141.385 74.9667H128.442V77.5988H141.385V74.9667Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M138.692 80.8397H131.196V85.3883H138.692V80.8397Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M134.914 67.178H128.442L131.25 70.4188H134.914H138.578L141.386 67.178H134.914Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M141.385 64.5459H128.442V67.1781H141.385V64.5459Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M138.692 70.4188H131.196V74.9674H138.692V70.4188Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M134.914 56.7572H128.442L131.25 59.9974H134.914H138.578L141.386 56.7572H134.914Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M141.385 54.125H128.442V56.7572H141.385V54.125Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M138.692 59.9973H131.196V64.5459H138.692V59.9973Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M136.84 49.1273H134.945H133.049L131.196 54.1249H134.945H138.693L136.84 49.1273Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M134.914 37.8195C133.177 39.588 131.028 46.2211 132.039 46.8531C133.05 47.4845 133.05 49.1274 133.05 49.1274H134.914H136.778C136.778 49.1274 136.778 47.4851 137.789 46.8531C138.799 46.2217 136.65 39.5886 134.914 37.8195Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M136.272 120.638H133.365V109.333L134.818 107.816L136.272 109.333V120.638Z",
    fill: "#37474F"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M136.272 102.254H133.365V96.8871L134.818 95.3711L136.272 96.8871V102.254Z",
    fill: "#37474F"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M206.437 91.2605H199.109V143.148H206.437V91.2605Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M202.772 88.0204H196.301L199.109 91.2605H202.772H206.436L209.244 88.0204H202.772Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M209.244 85.3882H196.301V88.0204H209.244V85.3882Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M202.868 77.5989H196.396L199.204 80.8397H202.868H206.532L209.34 77.5989H202.868Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M209.34 74.9667H196.396V77.5988H209.34V74.9667Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M206.647 80.8397H199.15V85.3883H206.647V80.8397Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M202.868 67.178H196.396L199.204 70.4188H202.868H206.532L209.34 67.178H202.868Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M209.34 64.5459H196.396V67.1781H209.34V64.5459Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M206.647 70.4188H199.15V74.9674H206.647V70.4188Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M202.868 56.7572H196.396L199.204 59.9974H202.868H206.532L209.34 56.7572H202.868Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M209.34 54.125H196.396V56.7572H209.34V54.125Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M206.647 59.9973H199.15V64.5459H206.647V59.9973Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M204.794 49.1273H202.899H201.004L199.15 54.1249H202.899H206.647L204.794 49.1273Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M202.868 37.8195C201.132 39.588 198.982 46.2211 199.993 46.8531C201.004 47.4845 201.004 49.1274 201.004 49.1274H202.868H204.732C204.732 49.1274 204.732 47.4851 205.743 46.8531C206.753 46.2217 204.605 39.5886 202.868 37.8195Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M204.226 120.638H201.319V109.333L202.772 107.816L204.226 109.333V120.638Z",
    fill: "#37474F"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M204.226 102.254H201.319V96.8871L202.772 95.3711L204.226 96.8871V102.254Z",
    fill: "#37474F"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M148.181 124.042H142.6V117.928C142.6 116.387 143.85 115.138 145.39 115.138C146.931 115.138 148.18 116.387 148.18 117.928L148.181 124.042Z",
    fill: "#37474F"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M148.181 137.372H142.6V131.257C142.6 129.717 143.85 128.468 145.39 128.468C146.931 128.468 148.18 129.717 148.18 131.257L148.181 137.372Z",
    fill: "#37474F"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M195.095 124.042H189.514V117.928C189.514 116.387 190.763 115.138 192.304 115.138C193.845 115.138 195.094 116.387 195.094 117.928V124.042H195.095Z",
    fill: "#37474F"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M195.095 137.372H189.514V131.257C189.514 129.717 190.763 128.468 192.304 128.468C193.845 128.468 195.094 129.717 195.094 131.257V137.372H195.095Z",
    fill: "#37474F"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M262.405 116.778H221.171C220.853 116.778 220.596 116.52 220.596 116.202C220.596 115.884 220.853 115.627 221.171 115.627H262.405C262.723 115.627 262.98 115.884 262.98 116.202C262.98 116.52 262.723 116.778 262.405 116.778Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M261.637 116.778H221.938V119.558H261.637V116.778Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M262.98 127.421H220.596V121.406C220.596 120.386 221.423 119.558 222.444 119.558H261.132C262.153 119.558 262.98 120.386 262.98 121.406V127.421Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M245.815 121.093H242.253V122.052H245.815V121.093Z",
    fill: "#37474F"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M255.707 124.737H252.144V125.696H255.707V124.737Z",
    fill: "#37474F"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M226.943 125.216H223.381V126.175H226.943V125.216Z",
    fill: "#37474F"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M252.144 123.49H248.582V124.449H252.144V123.49Z",
    fill: "#37474F"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M260.667 125.695H257.105V126.655H260.667V125.695Z",
    fill: "#37474F"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M234.466 122.531H230.904V123.49H234.466V122.531Z",
    fill: "#37474F"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M242.593 124.257H239.031V125.216H242.593V124.257Z",
    fill: "#37474F"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M260.465 121.572H256.903V122.531H260.465V121.572Z",
    fill: "#37474F"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M262.98 127.422H241.788H220.596L218.103 131.833H241.788H265.473L262.98 127.422Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M267.008 138.929H216.568V134.092C216.568 132.844 217.58 131.833 218.827 131.833H264.749C265.997 131.833 267.008 132.844 267.008 134.092L267.008 138.929Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M230.511 134.038H226.948V134.997H230.511V134.038Z",
    fill: "#37474F"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M250.363 134.901H246.801V135.86H250.363V134.901Z",
    fill: "#37474F"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M223.72 136.723H220.157V137.682H223.72V136.723Z",
    fill: "#37474F"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M239.031 134.901H235.469V135.86H239.031V134.901Z",
    fill: "#37474F"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M258.886 133.079H255.323V134.039H258.886V133.079Z",
    fill: "#37474F"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M258.684 137.203H255.122V138.162H258.684V137.203Z",
    fill: "#37474F"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M245.815 137.203H242.253V138.162H245.815V137.203Z",
    fill: "#37474F"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M264.055 135.381H260.492V136.34H264.055V135.381Z",
    fill: "#37474F"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M214.507 143.148V140.271",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M219.972 143.148V140.271",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M225.438 143.148V140.271",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M230.904 143.148V140.271",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M236.322 143.148H209.089V141.502C209.089 140.081 210.241 138.928 211.663 138.928H233.749C235.17 138.928 236.323 140.08 236.323 141.502V143.148H236.322ZM271.962 138.929H249.875C248.454 138.929 247.301 140.081 247.301 141.503V143.149H274.535V141.503C274.535 140.081 273.383 138.929 271.962 138.929Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M249.947 138.929H233.677C235.138 138.929 236.322 140.114 236.322 141.574V143.148H247.301V141.574C247.302 140.113 248.486 138.929 249.947 138.929Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M252.719 143.148V140.271",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M258.185 143.148V140.271",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M263.652 143.148V140.271",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M269.117 143.148V140.271",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M247.753 90.3124C246.556 90.0463 244.399 89.7315 242.671 90.3832C242.385 90.491 242.089 90.5495 241.789 90.5495C241.489 90.5495 241.191 90.491 240.906 90.3832C239.179 89.7315 237.021 90.0463 235.824 90.3124C235.297 90.4294 234.918 90.9697 234.918 91.5967C234.918 91.8826 234.995 92.1616 235.144 92.3871C235.531 92.9686 236.431 93.985 237.999 93.985C239.585 93.985 240.598 92.7979 241.038 92.1382C241.219 91.8672 241.495 91.7082 241.789 91.7082C242.082 91.7082 242.358 91.8672 242.539 92.1382C242.979 92.7979 243.993 93.985 245.578 93.985C247.147 93.985 248.047 92.968 248.433 92.3871C248.582 92.1616 248.659 91.8826 248.659 91.5967C248.659 90.9697 248.28 90.4294 247.753 90.3124Z",
    fill: "#37474F"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M262.781 98.4646L254.062 86.6873C254.062 86.6873 252.461 90.4658 251.821 94.0454C251.181 97.6249 250.54 98.52 248.939 100.807C248.175 101.899 247.678 103.081 247.368 104.019C247.005 105.115 246.083 105.907 244.978 106.079C242.864 106.407 240.712 106.407 238.598 106.079C237.493 105.907 236.571 105.115 236.208 104.019C235.898 103.081 235.401 101.899 234.637 100.807C233.036 98.52 232.395 97.6256 231.755 94.0454C231.115 90.4658 229.514 86.6873 229.514 86.6873L220.795 98.4646C220.194 99.2771 220.215 100.389 220.845 101.179C222.627 103.413 225.763 108.234 224.144 112.886H241.788H259.432C257.813 108.234 260.949 103.413 262.73 101.179C263.36 100.389 263.382 99.2771 262.781 98.4646Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M259.432 112.886C252.809 111.428 247.368 104.019 247.368 104.019C247.005 105.115 246.083 105.907 244.978 106.079C242.864 106.407 240.712 106.407 238.598 106.079C237.493 105.907 236.571 105.115 236.208 104.019C236.208 104.019 230.766 111.428 224.144 112.886C222.856 113.17 221.938 114.309 221.938 115.627H241.788H261.638C261.638 114.308 260.72 113.17 259.432 112.886Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M231.755 94.0454C231.693 93.6973 231.622 93.3474 231.543 92.9988C231.257 93.0684 228.441 93.847 230.308 97.2633C231.442 99.3362 232.701 99.4803 233.566 99.2315C232.703 97.872 232.229 96.6923 231.755 94.0454Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M252.033 92.9988C251.955 93.3468 251.883 93.6973 251.821 94.0454C251.347 96.6923 250.873 97.872 250.01 99.2315C250.875 99.4803 252.135 99.3362 253.268 97.2633C255.136 93.847 252.319 93.0684 252.033 92.9988Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M241.788 88.6572C240.963 88.6572 240.271 88.0326 240.187 87.2121L239.716 82.6155C239.619 81.6669 240.363 80.842 241.317 80.842H242.26C243.213 80.842 243.958 81.6669 243.861 82.6155L243.39 87.2121C243.305 88.0326 242.614 88.6572 241.788 88.6572Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M251.276 84.7998C250.791 84.4709 250.243 84.2473 249.665 84.142C247.715 83.7871 245.746 83.5654 243.772 83.4767L243.389 87.2121C243.305 88.0332 242.614 88.6572 241.788 88.6572C240.963 88.6572 240.271 88.0326 240.187 87.2121L239.804 83.4767C237.83 83.5654 235.862 83.7871 233.911 84.142C233.334 84.2467 232.785 84.4709 232.3 84.7998L229.514 86.6879C229.514 86.6879 231.115 90.4664 231.755 94.046C232.396 97.6256 233.036 98.5206 234.637 100.808C235.401 101.899 235.898 103.082 236.208 104.02C236.571 105.116 237.493 105.908 238.598 106.08C240.712 106.408 242.864 106.408 244.978 106.08C246.083 105.908 247.005 105.116 247.368 104.02C247.678 103.082 248.175 101.899 248.939 100.808C250.54 98.5206 251.181 97.6262 251.821 94.046C252.462 90.4664 254.062 86.6879 254.062 86.6879L251.276 84.7998Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5779 114.593V47.0194H60.086V79.8608",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9307 40.4147H29.7327V47.02H57.9307V40.4147Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M60.086 37.7726H27.5779V40.4146H60.086V37.7726Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9771 35.1774H31.6858V37.8194H55.9771V35.1774Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9771 35.1774H31.6858V37.8194H55.9771V35.1774Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9202 32.5354H35.7434V35.1774H51.9202V32.5354Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9617 42.5848H32.6973V47.02H34.9617V42.5848Z",
    fill: "#37474F"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9631 42.5848H37.6987V47.02H39.9631V42.5848Z",
    fill: "#37474F"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9639 42.5848H42.6995V47.02H44.9639V42.5848Z",
    fill: "#37474F"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9651 42.5848H47.7007V47.02H49.9651V42.5848Z",
    fill: "#37474F"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9658 42.5848H52.7014V47.02H54.9658V42.5848Z",
    fill: "#37474F"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8296 54.125V105.199",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8308 54.125V102.892",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8315 54.125V102.892",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8328 54.125V105.199",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8335 54.125V85.355",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08301 143.148H302.923",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M216.6 134.88L206.462 119.573",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M126.657 143.148H159.8H209.088",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M131.154 92.3743L116.437 114.593",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M186.048 88.7534L159.8 49.1273L141.386 76.928",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M221.107 143.148H298.429L221.107 26.4136L205.097 50.5854",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M199.01 59.7743L182.931 84.049",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M159.8 49.1273L148.112 87.4906",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M221.107 26.4136L208.177 64.5458",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M226.949 76.2831H214.642V80.2218H226.949V76.2831Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M294.017 136.487H281.94V132.549H291.408L294.017 136.487Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M243.403 69.942H231.097V73.8807H243.403V69.942Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M218.743 104.356H206.437V108.295H218.743V104.356Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M273.161 121.04H262.98V124.979H273.161V121.04Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M235.667 54.7877H223.36V58.7264H235.667V54.7877Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M169.526 69.942H160.582V72.8046H169.526V69.942Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M162.9 79.4081H153.956V82.2706H162.9V79.4081Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M185.313 87.6433H178.98V84.7808H183.416L185.313 87.6433Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7406 143.148H50.6853V166.133H85.7406V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3849 143.148H60.0405V156.709H76.3849V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0191 156.709H58.4062V159.489H78.0191V156.709Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3849 159.489H60.0405V166.134H76.3849V159.489Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6472 159.489H60.0405V166.134H63.6472V159.489Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6472 143.148H60.0405V156.709H63.6472V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0159 143.148H66.4092V156.709H70.0159V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3848 159.489H72.7781V166.134H76.3848V159.489Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3848 143.148H72.7781V156.709H76.3848V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4092 143.148H63.6477V156.709H66.4092V143.148Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7774 143.148H70.0159V156.709H72.7774V143.148Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.844 154.107V146.903",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2129 154.107V146.903",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5811 154.107V146.903",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4092 159.489H63.6477V166.134H66.4092V159.489Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7774 159.489H70.0159V166.134H72.7774V159.489Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.844 164.438V161.319",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2129 164.438V161.319",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5811 164.438V161.319",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8242 146.131H53.2214V152.802C53.2214 153.948 54.252 154.879 55.5228 154.879C56.7942 154.879 57.8242 153.949 57.8242 152.802V146.131Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2046 146.131H78.6018V152.802C78.6018 153.948 79.6324 154.879 80.9032 154.879C82.1746 154.879 83.2046 153.949 83.2046 152.802V146.131Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7406 166.134H50.6853V168.914H85.7406V166.134Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7406 168.913H50.6853V176.508H85.7406V168.913Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1528 172.859C70.1528 171.892 69.2842 171.109 68.213 171.109C67.1417 171.109 66.2732 171.892 66.2732 172.859C66.2732 173.825 67.1417 174.609 68.213 174.609C69.2842 174.609 70.1528 173.825 70.1528 172.859Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7406 176.508H50.6853V186.271H85.7406V176.508Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2337 176.508H50.6853V186.271H53.2337V176.508Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3599 176.508H58.8115V186.271H61.3599V176.508Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4869 176.508H66.9385V186.271H69.4869V176.508Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6136 176.508H75.0652V186.271H77.6136V176.508Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7405 176.508H83.1921V186.271H85.7405V176.508Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6853 183.322H85.7406",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8121 178.567H55.2339V181.262H56.8121V178.567Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9383 178.567H63.3601V181.262H64.9383V178.567Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0653 178.567H71.4871V181.262H73.0653V178.567Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.192 178.567H79.6138V181.262H81.192V178.567Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6853 186.271C50.6853 194.978 58.5073 202.035 68.1569 202.035H68.2696C77.9187 202.035 85.7412 194.977 85.7412 186.271H50.6853Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4775 186.271C59.4775 194.978 63.3762 202.035 68.1853 202.035H68.2414C73.0505 202.035 76.9491 194.977 76.9491 186.271H59.4775Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6852 143.148H43.1331V166.133H50.6852V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1331 143.148H27.5779V168.913H43.1331V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6852 166.134H43.1331V168.914H50.6852V166.134Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6853 154.878H27.5779",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9377 143.148H44.8801V148.674C44.8801 149.685 45.7887 150.505 46.9092 150.505C48.0297 150.505 48.9383 149.685 48.9383 148.674L48.9377 143.148Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3846 146.131H33.3264V150.284C33.3264 151.295 34.235 152.115 35.3555 152.115C36.476 152.115 37.3846 151.295 37.3846 150.284V146.131Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3846 158.946H33.3264V163.099C33.3264 164.11 34.235 164.93 35.3555 164.93C36.476 164.93 37.3846 164.11 37.3846 163.099V158.946Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9377 154.878H44.8801V160.404C44.8801 161.415 45.7887 162.235 46.9092 162.235C48.0297 162.235 48.9383 161.415 48.9383 160.404L48.9377 154.878Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5779 143.148H9.76807V168.913H27.5779V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5779 166.134H9.76807V168.914H27.5779V166.134Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8407 157.285H12.1353V163.489H14.8407V157.285Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0258 157.285H17.3203V163.489H20.0258V157.285Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2111 157.285H22.5056V163.489H25.2111V157.285Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8407 146.826H12.1353V153.03H14.8407V146.826Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0258 146.826H17.3203V153.03H20.0258V146.826Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2111 146.826H22.5056V153.03H25.2111V146.826Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9092 168.913H35.3555V172.71H46.9092V168.913Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0918 172.711H36.1724V175.694H46.0918V172.711Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1323 179.084L37.3845 175.694H41.1323H44.88L41.1323 179.084Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7598 172.711V174.609",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1323 172.711V174.609",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5044 172.711V174.609",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7403 166.134H93.2925V143.148H85.7403V166.134Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2924 168.913H108.848V143.148H93.2924V168.913Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7403 168.913H93.2925V166.133H85.7403V168.913Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7405 154.878H108.848",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4874 143.148H91.545V148.674C91.545 149.685 90.637 150.505 89.5159 150.505C88.3954 150.505 87.4868 149.685 87.4868 148.674L87.4874 143.148Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0411 146.131H103.099V150.284C103.099 151.295 102.19 152.115 101.07 152.115C99.9491 152.115 99.0405 151.295 99.0405 150.284L99.0411 146.131Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0411 158.946H103.099V163.099C103.099 164.11 102.19 164.93 101.07 164.93C99.9491 164.93 99.0405 164.11 99.0405 163.099L99.0411 158.946Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4874 154.878H91.545V160.404C91.545 161.415 90.637 162.235 89.5159 162.235C88.3954 162.235 87.4868 161.415 87.4868 160.404L87.4874 154.878Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.848 168.913H126.657V143.148H108.848V168.913Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.848 168.913H126.657V166.133H108.848V168.913Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.585 163.489H124.29V157.285H121.585V163.489Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.399 163.489H119.105V157.285H116.399V163.489Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.215 163.489H113.92V157.285H111.215V163.489Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.585 153.031H124.29V146.827H121.585V153.031Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.399 153.031H119.105V146.827H116.399V153.031Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.215 153.031H113.92V146.827H111.215V153.031Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5164 172.71H101.07V168.913H89.5164V172.71Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3337 175.694H100.253V172.71H90.3337V175.694Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2935 179.084L99.0413 175.694H95.2935H91.5452L95.2935 179.084Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6653 172.711V174.609",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2935 172.711V174.609",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9209 172.711V174.609",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.482 143.148H152.127V179.084H185.482V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.127 143.148H138.482V179.084H152.127V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.127 143.148H185.482V179.084H199.127V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.128 175.694H138.482V179.084H199.128V175.694Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.128 172.303H138.482V175.694H199.128V172.303Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.172 143.148H154.907V162.235L159.54 165.397L164.172 162.235V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.993 143.148H156.086V155.78L159.54 157.873L162.993 155.78V143.148Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.258 143.148H165.352V155.78L168.805 157.873L172.258 155.78V143.148Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.524 143.148H174.617V155.78L178.07 157.873L181.524 155.78V143.148Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.437 143.148H164.172V162.235L168.805 165.397L173.437 162.235V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.703 143.148H173.437V162.235L178.07 165.397L182.703 162.235V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.881 165.397H155.729V167.523H181.881V165.397Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.309 179.084H138.482V182.42H141.309V179.084Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.733 179.084H144.906V182.42H147.733V179.084Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.158 179.084H151.331V182.42H154.158V179.084Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.582 179.084H157.755V182.42H160.582V179.084Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.006 179.084H164.179V182.42H167.006V179.084Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.431 179.084H170.604V182.42H173.431V179.084Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.855 179.084H177.028V182.42H179.855V179.084Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.279 179.084H183.452V182.42H186.279V179.084Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.703 179.084H189.876V182.42H192.703V179.084Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.128 179.084H196.301V182.42H199.128V179.084Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.028 179.084H160.582V188.576H177.028V179.084Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.529 188.577H179.081",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.582 188.577V189.783C160.582 193.881 164.264 197.203 168.805 197.203C173.347 197.203 177.028 193.881 177.028 189.783V188.577H160.582Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.763 187.133V184.245",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.784 187.133V184.245",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.805 187.133V184.245",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.826 187.133V184.245",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.847 187.133V184.245",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.253 179.084H141.29V186.566H154.253V179.084Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.672 186.566H155.871",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.29 186.566V187.517C141.29 190.747 144.192 193.366 147.772 193.366C151.351 193.366 154.253 190.747 154.253 187.517V186.566H141.29Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.009 185.428V183.152",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.391 185.428V183.152",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.772 185.428V183.152",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.153 185.428V183.152",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.534 185.428V183.152",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.358 179.084H183.395V186.566H196.358V179.084Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.777 186.566H197.976",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.395 186.566V187.517C183.395 190.747 186.297 193.366 189.876 193.366C193.456 193.366 196.358 190.747 196.358 187.517V186.566H183.395Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.114 185.428V183.152",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.496 185.428V183.152",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.876 185.428V183.152",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.257 185.428V183.152",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.639 185.428V183.152",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.482 143.148H131.154V189.966H138.482V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.818 192.89H128.347L131.154 189.966H134.818H138.482L141.29 192.89H134.818Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.29 192.89H128.347V195.265H141.29V192.89Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.272 163.459H133.365V173.66L134.818 175.028L136.272 173.66V163.459Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.272 180.047H133.365V184.89L134.818 186.257L136.272 184.89V180.047Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.437 143.148H199.109V189.966H206.437V143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.772 192.89H196.301L199.109 189.966H202.772H206.436L209.244 192.89H202.772Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.244 192.89H196.301V195.265H209.244V192.89Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.226 163.459H201.319V173.66L202.772 175.028L204.226 173.66V163.459Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.226 180.047H201.319V184.89L202.772 186.257L204.226 184.89V180.047Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.181 160.387H142.6V165.632C142.6 167.173 143.85 168.422 145.39 168.422C146.931 168.422 148.18 167.173 148.18 165.632L148.181 160.387Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.181 148.36H142.6V153.605C142.6 155.145 143.85 156.395 145.39 156.395C146.931 156.395 148.18 155.145 148.18 153.605L148.181 148.36Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.095 160.387H189.514V165.632C189.514 167.173 190.763 168.422 192.304 168.422C193.845 168.422 195.094 167.173 195.094 165.632V160.387H195.095Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.095 148.36H189.514V153.605C189.514 155.145 190.763 156.395 192.304 156.395C193.845 156.395 195.094 155.145 195.094 153.605V148.36H195.095Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.461 166.942H221.114C220.827 166.942 220.595 167.175 220.595 167.462C220.595 167.749 220.827 167.981 221.114 167.981H262.461C262.747 167.981 262.98 167.749 262.98 167.462C262.98 167.175 262.748 166.942 262.461 166.942Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.637 164.433H221.938V166.942H261.637V164.433Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.98 157.338H220.596V162.585C220.596 163.606 221.423 164.433 222.444 164.433H261.132C262.153 164.433 262.98 163.606 262.98 162.585V157.338Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.815 162.183H242.253V163.049H245.815V162.183Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.707 158.896H252.144V159.761H255.707V158.896Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.943 158.463H223.381V159.328H226.943V158.463Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.144 160.02H248.582V160.886H252.144V160.02Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.667 158.03H257.105V158.896H260.667V158.03Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.466 160.885H230.904V161.751H234.466V160.885Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.593 159.328H239.031V160.193H242.593V159.328Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.465 161.751H256.903V162.616H260.465V161.751Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.98 157.338H241.788H220.596L218.103 153.358H241.788H265.473L262.98 157.338Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.008 146.955H216.568V151.099C216.568 152.346 217.58 153.358 218.827 153.358H264.749C265.997 153.358 267.008 152.346 267.008 151.099L267.008 146.955Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.511 150.502H226.948V151.368H230.511V150.502Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.363 149.724H246.801V150.589H250.363V149.724Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.72 148.08H220.157V148.945H223.72V148.08Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.031 149.724H235.469V150.589H239.031V149.724Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.886 151.368H255.323V152.234H258.886V151.368Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.684 147.647H255.122V148.513H258.684V147.647Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.815 147.647H242.253V148.513H245.815V147.647Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.055 149.292H260.492V150.157H264.055V149.292Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.507 143.148V145.744",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.972 143.148V145.744",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.438 143.148V145.744",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.904 143.148V145.744",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.322 146.955H209.089V145.721C209.089 144.3 210.241 143.147 211.663 143.147H233.749C235.17 143.147 236.323 144.3 236.323 145.721V146.955H236.322ZM271.962 143.148H249.875C248.454 143.148 247.301 144.301 247.301 145.722V146.956H274.535V145.722C274.535 144.301 273.383 143.148 271.962 143.148Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.947 146.955H233.677C235.138 146.955 236.322 145.886 236.322 144.568V143.147H247.301V144.568C247.302 145.887 248.486 146.955 249.947 146.955Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.719 143.148V145.744",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.185 143.148V145.744",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.652 143.148V145.744",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.117 143.148V145.744",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.753 190.822C246.556 191.062 244.399 191.346 242.671 190.757C242.385 190.66 242.089 190.607 241.789 190.607C241.489 190.607 241.191 190.66 240.906 190.757C239.179 191.346 237.021 191.061 235.824 190.822C235.297 190.716 234.918 190.228 234.918 189.662C234.918 189.405 234.995 189.153 235.144 188.95C235.531 188.425 236.431 187.507 237.999 187.507C239.585 187.507 240.598 188.579 241.038 189.174C241.219 189.418 241.495 189.562 241.789 189.562C242.082 189.562 242.358 189.418 242.539 189.174C242.979 188.579 243.993 187.507 245.578 187.507C247.147 187.507 248.047 188.425 248.433 188.95C248.582 189.153 248.659 189.405 248.659 189.662C248.659 190.228 248.28 190.716 247.753 190.822Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.781 183.466L254.062 194.092C254.062 194.092 252.461 190.683 251.821 187.453C251.181 184.224 250.54 183.416 248.939 181.352C248.175 180.367 247.678 179.3 247.368 178.454C247.005 177.465 246.083 176.75 244.978 176.596C242.864 176.299 240.712 176.299 238.598 176.596C237.493 176.75 236.571 177.465 236.208 178.454C235.898 179.3 235.401 180.367 234.637 181.352C233.036 183.416 232.395 184.224 231.755 187.453C231.115 190.683 229.514 194.092 229.514 194.092L220.795 183.466C220.194 182.733 220.215 181.729 220.845 181.017C222.627 179 225.763 174.652 224.144 170.453H241.788H259.432C257.813 174.651 260.949 179 262.73 181.017C263.36 181.729 263.382 182.733 262.781 183.466Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.432 170.453C252.809 171.769 247.368 178.454 247.368 178.454C247.005 177.465 246.083 176.75 244.978 176.596C242.864 176.299 240.712 176.299 238.598 176.596C237.493 176.75 236.571 177.465 236.208 178.454C236.208 178.454 230.766 171.769 224.144 170.453C222.856 170.198 221.938 169.17 221.938 167.981H241.788H261.638C261.638 169.17 260.72 170.197 259.432 170.453Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.755 187.453C231.693 187.767 231.622 188.083 231.543 188.398C231.257 188.335 228.441 187.633 230.308 184.55C231.442 182.68 232.701 182.549 233.566 182.774C232.703 184.001 232.229 185.064 231.755 187.453Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.033 188.398C251.955 188.083 251.883 187.767 251.821 187.453C251.347 185.065 250.873 184.001 250.01 182.774C250.875 182.549 252.135 182.679 253.268 184.55C255.136 187.633 252.319 188.335 252.033 188.398Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.788 192.315C240.963 192.315 240.271 192.878 240.187 193.619L239.716 197.766C239.619 198.622 240.363 199.366 241.317 199.366H242.26C243.213 199.366 243.958 198.622 243.861 197.766L243.39 193.619C243.305 192.878 242.614 192.315 241.788 192.315Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.276 195.796C250.791 196.093 250.243 196.295 249.665 196.389C247.715 196.709 245.746 196.909 243.772 196.99L243.389 193.619C243.305 192.878 242.614 192.315 241.788 192.315C240.963 192.315 240.271 192.878 240.187 193.619L239.804 196.99C237.83 196.909 235.862 196.709 233.911 196.389C233.334 196.294 232.785 196.092 232.3 195.796L229.514 194.092C229.514 194.092 231.115 190.683 231.755 187.453C232.396 184.224 233.036 183.416 234.637 181.352C235.401 180.367 235.898 179.3 236.208 178.454C236.571 177.465 237.493 176.75 238.598 176.596C240.712 176.299 242.864 176.299 244.978 176.596C246.083 176.75 247.005 177.465 247.368 178.454C247.678 179.3 248.175 180.367 248.939 181.352C250.54 183.416 251.181 184.224 251.821 187.453C252.462 190.683 254.062 194.092 254.062 194.092L251.276 195.796Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5779 168.913V229.885H60.086V200.252",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8296 223.473V177.389",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8308 223.473V179.471",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8315 223.473V179.471",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8328 223.473V177.389",
    stroke: "#37474F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.08301 143.148H302.923",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.6 150.608L206.462 164.42",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.657 143.148H159.8H209.088",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.154 188.961L116.437 168.913",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.048 192.229L159.8 227.982L141.386 202.898",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.107 143.148H298.429L221.107 248.477L205.097 226.667",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.017 149.158H281.94V152.712H291.408L294.017 149.158Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.743 174.596H206.437V178.15H218.743V174.596Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.161 159.542H262.98V163.096H273.161V159.542Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.313 193.229H178.98V195.812H183.416L185.313 193.229Z",
    stroke: "#37474F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7878 7.42041H52.8813",
    stroke: "#FF9100",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2524 1.87646H71.6484",
    stroke: "#FF9100",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2954 6.39355H79.1445",
    stroke: "#FF9100",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3162 13.1696H64.5693",
    stroke: "#FF9100",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M137.375 24.7714H167.456",
    stroke: "#FF9100",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M152.415 28.0565H174.082",
    stroke: "#FF9100",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M244.035 2.59534H277.975",
    stroke: "#FF9100",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M261.005 7.52332H287.979",
    stroke: "#FF9100",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M237.25 7.52332H250.363",
    stroke: "#FF9100",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M252.144 11.6296H273.161",
    stroke: "#FF9100",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgipt);
export default __webpack_public_path__ + "static/media/egipt.f773508dc34fc5641ee06a9ed457bbcd.svg";
export { ForwardRef as ReactComponent };